import actions from "./actions";
import s2rService from "../../../common/services/s2r-service";
import { v4 as uuidv4 } from "uuid";

const error = {
  description:
    "There was an error rendering your image. Please report this issue to contact vizcom@gmail.com or join our discord",
  message: "S2R Render Error",
};

const renderOnyx = (req) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    dispatch(actions.renderImageStarted());
    try {
      const response = await s2rService.renderOnyx(req);

      const image = {
        src: response,
        imageType: "render",
        id: uuidv4(),
      };

      dispatch(actions.renderImageFinished(image));
      dispatch(actions.renderSelected(image));
      window.analytics.track("SK2R Rendered Image", {
        shader: "onyx",
        device: "mobile",
      });
      resolve(response.data);
    } catch (e) {
      dispatch(actions.renderImageError(e));
      window.analytics.track("Error Log", {
        category: "S2R",
        action: "render",
        shader: "onyx",
        error: e,
      });
      reject(error);
    }
  });
};

const renderClassic = (req) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    dispatch(actions.renderImageStarted());
    try {
      const response = await s2rService.renderClassic(req);
      const image = {
        src: response,
        imageType: "render",
        id: uuidv4(),
      };
      dispatch(actions.renderImageFinished(image));
      dispatch(actions.renderSelected(image));
      window.analytics.track("S2R Rendered Image", {
        shader: "classic",
        device: "mobile",
      });
      resolve(response.data);
    } catch (e) {
      window.analytics.track("Error Log", {
        category: "S2R",
        action: "render",
        shader: "classic",
        error: e,
      });
      dispatch(actions.renderImageError(error));
      reject(error);
    }
  });
};

// eslint-disable-next-line import/no-anonymous-default-export
const SKRThunks = {
  renderClassic,
  renderOnyx,
};

export default SKRThunks;
